import { AppBar, Avatar, Box, Container, FormControl, Icon, IconButton, InputLabel, Menu, MenuItem, Select, SelectChangeEvent, Toolbar, Tooltip, Typography } from '@mui/material';
import { AxiosError } from 'axios';
import { CustomSelect } from 'components/CustomSelect';
import DialogContext from 'components/confirm-dialog-context';
import SideMenu from 'components/sidemenu/SideMenu';
import useCatchApiError from 'hooks/useCatchApiError';
import { useSnackbarCustom } from 'hooks/useSnackCustom';
import { IAbstractModel } from 'model/abstract.model';
import CaixaService from 'pages/Caixa/caixa.service';
import ConfiguracaoDescontoAcrescimoService from 'pages/Configuracoes/configuracao-desconto-acrescimo.service';
import ConfiguracaoConsignadoService from 'pages/Configuracoes/consignado/configuracao-consignado.service';
import { SituacaoConsignado } from 'pages/consignado/situacao-consignado.model';
import LoginService from "pages/login/login.service";
import ConfirmacaoExcluirSkuDialog, { DialogConfirmacaoExcluirSku } from 'pages/registra-venda/confirmacao-excluir-sku-dialog';
import RegistraVendaService from 'pages/registra-venda/registra-venda.service';
import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { resetLoading } from 'redux/features/blockuiSlice';
import { resetCaixa, setCaixa } from 'redux/features/caixaSlice';
import { resetConfiguracoes, setCanalVendaPadrao, setConfiguracaoDesconto, setConfiguracaoPedidoBalcao, setConfiguracaoPoliticaVenda, setConsignadoConfiguracao, setDeposito, setDepositoPadrao, setTabelaPreco, setTabelaPrecoPadrao } from 'redux/features/configuracoes';
import { atualizaValoresItensConsignado, resetConsignado, setDepositoConsignado, setTabelaPrecoConsignado } from 'redux/features/consignadoSlice';
import { resetDesconto } from 'redux/features/descontoFixoSlice';
import { resetEsSelecionado, setEsSelecionado } from 'redux/features/esSelecionadoSlice';
import { resetChavesReferenciadas } from 'redux/features/notaReferenciadaSlice';
import { resetPagamento } from 'redux/features/pagamentoSlice';
import { atualizaValoresItensPedido, changeTabelaPrecoPadraoPedido, resetPreferencias, resetSkusConsultados, resetState, setCanalVenda, setProdutos } from 'redux/features/stateSlice';
import { resetStepper } from 'redux/features/stepperSlice';
import { resetToken } from 'redux/features/tokenSlice';
import { resetValePresenteState } from 'redux/features/valePresenteSlice';
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import useCustomLocation from 'utils/useCustomLocation';
import { deepCopy, sortArray } from 'utils/util';
import { axiosRequest } from '../../../src/axios/axios.config';
import peonFlowImage from '../../assets/peonFlowLogo.svg';
import useTabelaPreco from './tabela-preco';
import './topBar.css';
import { ConfiguracaoPedidoBalcaoTO } from './topBar.model';
import topBarService from './topbar.service';
import { theme } from 'theme';

type topBarProps = {
    showConfiguracoes: boolean;
    onOpen: () => void;
    onCloseConfiguracoesMenu: () => void;
};

const initialState: DialogConfirmacaoExcluirSku = {
    data: [],
    length: 0,
    produtosParaExcluir: [],
    showConfirmaExclusao: false,
    tabelaPrecoTemp: null
};

const Topbar = (props: topBarProps) => {
    const token = useAppSelector((state) => state.token);
    const dispatch = useAppDispatch();
    const dialog = useContext(DialogContext);
    const service = topBarService();
    const configuracaoDescontoService = ConfiguracaoDescontoAcrescimoService();
    const registraVendaService = RegistraVendaService();

    const settings = [
        {
            label: 'Atendimento',
            action: () => {
                onEnviaAtendimento()
            }
        },
        {
            label: 'Sair',
            action: () => {
                handleLogout();
            },
        },
    ];

    const onEnviaAtendimento = useCallback(() => {
        setTimeout(() => {
            window.open("https://produtec.mysuite1.com.br/client/login.php")
        }, 300);
        handleCloseUserMenu()
    }, [])

    const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null);
    const navigate = useNavigate();
    const { quantidadeTotal, itens, itensTroca } = useAppSelector(e => e.state.pedido);
    const { tableData, tabelaPreco: tabelaPrecoConsignado, deposito: depositoConsignado } = useAppSelector(e => e.consignado);
    const estabelecimento = useAppSelector(e => e.estabelecimentoSelecionado);
    const { configuracaoPedidoBalcao, configuracaoConsignado } = useAppSelector(e => e.configuracoes);
    const tabelaPrecoRef = useRef<IAbstractModel | null>(configuracaoPedidoBalcao.tabelaPreco);
    const depositoRef = useRef<IAbstractModel | null>(configuracaoPedidoBalcao.deposito);
    const location = useLocation();
    const {
        isTelaPreVenda,
        isTelaRegistraVenda,
        isTelaFinancasGestaoReceber,
        isTelaRegistraConsignado,
        isTelaDevolucaoConsignado,

    } = useCustomLocation();
    const { throwErrorMessage } = useCatchApiError();
    const { addError, closeSnack } = useSnackbarCustom();
    const loginService = LoginService();
    const caixaService = CaixaService();
    const configuracaoConsignadoService = ConfiguracaoConsignadoService();

    const { dadosAlterarTabelaPrecoState, setDadosAlterarTabelaPrecoState, atualizarOuRemoverItensPedido } = useTabelaPreco();
    const preferenciaTabelaPreco = useAppSelector(s => s.preferencias.tabelasPreco);

    const isTelasConsignado = () => {
        return isTelaRegistraConsignado() || isTelaDevolucaoConsignado();
    };

    const getItensToUse = () => {
        return isTelasConsignado() ? tableData[SituacaoConsignado.ABERTO] : [...itens, ...itensTroca];
    };

    useEffect(() => {
        closeSnack('topbar-falha-saldo-conta');
        closeSnack('topbar-falha-caixas-disponiveis');
        closeSnack('sem-caixa');
        axiosRequest.get(`/flow/existe-configuracao`, { headers: loginService.getHeaders() })
            .then(() => {
                setDadosAlterarTabelaPrecoState(prevState => ({ ...prevState, error: false }));
                caixaService.getCaixas()
                    .then(({ data }) => {
                        const caixa = data.find(e => e.caixaAberto && e.operadorAtual === token.USER_INFO?.username);
                        if (!!caixa) {
                            caixaService.getSaldoConta(caixa.uuid)
                                .then(({ data }) => {
                                    dispatch(setCaixa({
                                        caixa: data.caixa,
                                        contaSelecionada: null,
                                        saldo: data.saldo,
                                        dataAbertura: data.dataAbertura,
                                        caixaAberto: data.caixaAberto
                                    }));
                                })
                                .catch(() => {
                                    addError({ id: 'topbar-falha-saldo-conta', message: 'Falha ao pegar o saldo da conta informada.', closeable: true });
                                });
                        }
                        else {
                            if (isTelaRegistraVenda() || isTelaRegistraConsignado()) {
                                setTimeout(() => {
                                    addError({ id: 'sem-caixa', preventDuplicate: true, message: 'Sem caixa aberto neste estabelecimento, redirecionando para tela de caixas para abrir', closeable: true });
                                }, 500);
                                navigate("/caixa");
                            }
                            dispatch(resetCaixa());
                        }
                    }).catch(() => {
                        addError({ id: 'topbar-falha-caixas-disponiveis', message: 'Falha ao pegar caixas disponiveis.', closeable: true });
                        navigate("/caixa");
                    });
            }).catch((error: AxiosError) => {
                navigate("/caixa");
                if (isTelaFinancasGestaoReceber() &&
                    (error.response?.data as any)?.objects &&
                    (error.response?.data as any)?.objects[0].name === "Estabelecimento sem configuração de pedido balcão") {
                    return;
                }
                setDadosAlterarTabelaPrecoState(prevState => ({ ...prevState, error: true }));
                dispatch(resetCaixa());
                throwErrorMessage((error as any));
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [estabelecimento.uuid]);

    useEffect(() => {
        service.getConfiguracao()
            .then(({ data }: { data: ConfiguracaoPedidoBalcaoTO; }) => {
                dispatch(setConfiguracaoPedidoBalcao(data));
                if (data.tabelaPreco) {
                    dispatch(setTabelaPrecoPadrao(data.tabelaPreco));
                }
                if (data.deposito) {
                    dispatch(setDepositoPadrao(data.deposito));
                }
            })
            .catch(() => { });

        configuracaoConsignadoService.getConfiguracao()
            .then(({ data }) => {
                dispatch(setConsignadoConfiguracao(data));
                if (data.tabelaPrecoPadrao) {
                    dispatch(setTabelaPrecoConsignado(data.tabelaPrecoPadrao));
                }
                if (data.depositoPadrao) {
                    dispatch(setDepositoConsignado(data.depositoPadrao));
                }
            })
            .catch(() => { });

        configuracaoDescontoService.getConfiguracaoPoliticaVenda()
            .then(({ data }) => {
                dispatch(setConfiguracaoPoliticaVenda(data));
            })
            .catch(() => { });

        getConfiguracaoDescontoUser();

        //eslint-disable-next-line
    }, [estabelecimento.uuid]);

    const getConfiguracaoDescontoUser = () => {
        configuracaoDescontoService.findByUserName()
            .then(({ data }) => {
                dispatch(setConfiguracaoDesconto(data));
            })
            .catch(() => { });
    };

    const getCanalVendaPadrao = useCallback(async () => {
        try {
            const { data } = await registraVendaService.getCanalVendaPadrao();
            if (data) {
                dispatch(setCanalVenda(data));
                dispatch(setCanalVendaPadrao(data));
            }
        } catch (err) {
            throwErrorMessage(err ?? []);
        }
        //eslint-disable-next-line
    }, [estabelecimento.uuid]);

    useEffect(() => {
        getCanalVendaPadrao();
        //eslint-disable-next-line
    }, [estabelecimento.uuid]);

    useEffect(() => {
        if (isTelasConsignado()) {
            const tabelaPadrao = tabelaPrecoConsignado ?? configuracaoConsignado?.tabelaPrecoPadrao ?? null;
            tabelaPrecoRef.current = tabelaPadrao;
            if (!tabelaPrecoConsignado) {
                dispatch(setTabelaPrecoConsignado(tabelaPadrao));
            }
        } else {
            tabelaPrecoRef.current = configuracaoPedidoBalcao.tabelaPreco;
            if (configuracaoPedidoBalcao.tabelaPreco?.uuid) {
                dispatch(changeTabelaPrecoPadraoPedido(configuracaoPedidoBalcao.tabelaPreco));
            }
        }
        //eslint-disable-next-line
    }, [configuracaoPedidoBalcao.tabelaPreco, configuracaoConsignado?.tabelaPrecoPadrao, tabelaPrecoConsignado, isTelasConsignado()]);

    useEffect(() => {
        if (isTelasConsignado()) {
            dispatch(setDepositoConsignado(configuracaoConsignado?.depositoPadrao ?? null));
        } else {
            depositoRef.current = configuracaoPedidoBalcao.deposito;
        }
        //eslint-disable-next-line
    }, [configuracaoPedidoBalcao.deposito, configuracaoConsignado?.depositoPadrao, isTelasConsignado()]);

    const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const handleLogout = () => {
        dispatch(resetToken());
        dispatch(resetEsSelecionado());
        dispatch(resetState());
        dispatch(resetDesconto());
        dispatch(resetStepper());
        dispatch(resetPagamento());
        dispatch(resetLoading());
        dispatch(resetCaixa());
        dispatch(resetConfiguracoes());
        dispatch(resetValePresenteState());
        dispatch(resetChavesReferenciadas());
        dispatch(resetPreferencias());
        dispatch(resetConsignado());
        navigate('/login');
    };

    const limpaTudo = (value: string) => {
        const found = token.ESTABELECIMENTOS.find((estabelecimento) => estabelecimento.uuid === value);
        if (found) dispatch(setEsSelecionado(found));
        dispatch(resetState());
        dispatch(resetDesconto());
        dispatch(resetPagamento());
        dispatch(resetCaixa());
        dispatch(resetChavesReferenciadas());
        dispatch(resetPreferencias());
        dispatch(resetConsignado());
    };

    const handleEstabelecimentoSelecionado = (event: SelectChangeEvent) => {
        if (estabelecimento.uuid !== event.target.value) {
            if (quantidadeTotal === 0) {
                return limpaTudo(event.target.value);
            }
            const novoEstabelecimentoDescritivo = token.ESTABELECIMENTOS.filter(e => e.uuid === event.target.value)[0].descritivo;
            return dialog.confirm({
                title: 'Atenção',
                message: `Deseja realmente trocar para o estabelecimento ${novoEstabelecimentoDescritivo}? Todos os dados informados serão perdidos`,
                onConfirm: () => {
                    limpaTudo(event.target.value);
                }
            });
        }
    };

    const toggleConfiguracoes = () => {
        if ((isTelaRegistraVenda() || isTelaPreVenda() || isTelasConsignado())) {
            if (props.showConfiguracoes) return props.onCloseConfiguracoesMenu();
            return props.onOpen();
        };
    };

    useEffect(() => {
        if ((!isTelaRegistraVenda() || !isTelaPreVenda() || !isTelasConsignado) && props.showConfiguracoes) {
            props.onCloseConfiguracoesMenu();
        }
        //eslint-disable-next-line
    }, [location]);

    const atualizaTabelaPreco = useCallback((tabelaPreco: IAbstractModel) => {
        if (isTelasConsignado()) {
            dispatch(setTabelaPrecoConsignado(tabelaPreco));
        } else {
            dispatch(setTabelaPreco(tabelaPreco));
        }
        tabelaPrecoRef.current = tabelaPreco;
        //eslint-disable-next-line
    }, [isTelasConsignado()]);

    const onSelectDeposito = (depositoUuid: string) => { // aqui
        if (isTelasConsignado()) {
            const deposito = configuracaoConsignado?.depositos.find(item => item.uuid === depositoUuid);
            if (deposito) {
                dispatch(setDepositoConsignado(deposito));
            }
        } else {
            const deposito = configuracaoPedidoBalcao.depositos.find(item => item.uuid === depositoUuid);
            const revalidateItens = deepCopy(itens);
            revalidateItens.forEach(e => e.estoque = -1);
            if (deposito) {
                dispatch(setDeposito(deposito));
            }
            dispatch(resetSkusConsultados());
            dispatch(setProdutos(revalidateItens));
        }
    };

    const onSelectTabelaPreco = (tabelaPrecoUuid: string) => {
        const tabelaPreco = getTabelasDePreco().find(s => s.uuid === tabelaPrecoUuid);
        if (!tabelaPreco) return;
        if (!!getItensToUse().length && tabelaPrecoRef.current?.uuid !== tabelaPrecoUuid) {
            return dialog.confirm({
                title: 'Atenção',
                message: `O valor dos produtos serão atualizados de acordo com a tabela de preço informada e, caso não haja preço na nova tabela, os produtos serão removidos do pedido. Deseja continuar?`,
                onConfirm: () => {
                    atualizarOuRemoverItensPedido(tabelaPreco, atualizaTabelaPreco);
                    // setTimeout(() => {
                    //     addSuccess({
                    //         id: 'tabela-preco-salva-com-sucesso',
                    //         message: 'Tabela de Preço alterada com sucesso!',
                    //         closeable: true,
                    //         hideDuration: 5000,
                    //         preventDuplicate: true
                    //     });
                    // }, 500);
                },
                onCancel: () => {
                    props.onCloseConfiguracoesMenu();
                }
            });
        }
        atualizaTabelaPreco(tabelaPreco);
        //eslint-disable-next-line
    };

    const onCloseModalSkus = () => {
        setDadosAlterarTabelaPrecoState(prevState => ({
            ...prevState,
            data: initialState.data,
            length: initialState.length,
            produtosParaExcluir: initialState.produtosParaExcluir,
            showConfirmaExclusao: initialState.showConfirmaExclusao,
            tabelaPrecoTemp: initialState.tabelaPrecoTemp
        }));
    };

    const onConfirmModalSkus = () => {
        if (isTelasConsignado()) {
            dispatch(atualizaValoresItensConsignado(dadosAlterarTabelaPrecoState.data));
        } else {
            dispatch(atualizaValoresItensPedido(dadosAlterarTabelaPrecoState.data));
        }
        if (dadosAlterarTabelaPrecoState.tabelaPrecoTemp) {
            atualizaTabelaPreco(dadosAlterarTabelaPrecoState.tabelaPrecoTemp);
        }
        onCloseModalSkus();
        props.onCloseConfiguracoesMenu();
    };

    const getTabelasDePreco = () => {
        if (!!preferenciaTabelaPreco?.length) return preferenciaTabelaPreco;
        if (isTelasConsignado()) return configuracaoConsignado?.tabelasPreco ?? [];
        return configuracaoPedidoBalcao.tabelasPreco;
    };

    const getDepositos = () => {
        return (isTelasConsignado() ? configuracaoConsignado?.depositos : configuracaoPedidoBalcao.depositos) ?? [];
    };

    const getDepositoUUID = () => {
        return isTelasConsignado() ? depositoConsignado?.uuid : configuracaoPedidoBalcao.deposito?.uuid;
    };


    return (
        <>
            <AppBar position="fixed"
                style={{
                    background: theme.palette.primary.main,
                    zIndex: 10
                }}>
                <Container maxWidth="xl">
                    <Toolbar>
                        <Box sx={{ flexGrow: 1, height: '64px', display: 'flex', alignItems: 'center', gap: '10px', userSelect: 'none' }}>
                            <button
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    padding: 0,
                                    // cursor: 'pointer',
                                }}
                            // onClick={() => navigate('/registra-venda')}
                            >
                                <img
                                    src="flow-icon-white-512.png"
                                    alt="flow-logo-icon"
                                    style={{
                                        width: '15px',
                                        maxHeight: '100%',
                                    }}
                                />
                            </button>
                            <button
                                id='peonFlowButton'
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    padding: 0,
                                    // cursor: 'pointer',
                                }}
                            // onClick={() => navigate('/registra-venda')}
                            >
                                <img
                                    id='peonFlowImage'
                                    src={peonFlowImage}
                                    alt="Background"
                                    style={{
                                        width: '150px',
                                        maxHeight: '100%',
                                        objectFit: 'cover',
                                    }}
                                />
                            </button>

                        </Box>

                        <Box
                            sx={{
                                flexGrow: 0,
                                display: 'flex',
                                alignItems: 'center',
                                gap: '15px',
                                '.MuiInput-underline::before': {
                                    borderBottomColor: `${theme.palette.background.default} !important`,
                                },
                                '.MuiInput-underline::after': {
                                    borderBottomColor: `${theme.palette.background.default} !important`,
                                },
                            }}>
                            <Box>
                                <FormControl variant="standard" sx={{ mb: 2 }}>
                                    <InputLabel htmlFor="estabelecimentos" />
                                    <Select variant='standard'
                                        sx={{
                                            color: theme.palette.background.default,
                                            fontWeight: '600',
                                            fontSize: '16px',
                                            fontFamily: 'Work Sans',
                                            ".MuiSelect-iconStandard": {
                                                fill: theme.palette.background.default
                                            },

                                        }}
                                        value={estabelecimento.uuid}
                                        id="SelecionaEstabelecimento"
                                        inputProps={{
                                            name: 'estabelecimentos',
                                            id: 'estabelecimentos',
                                        }}
                                        onChange={handleEstabelecimentoSelecionado}
                                    >
                                        {token.ESTABELECIMENTOS.map((estabelecimento, index) =>
                                            <MenuItem value={estabelecimento.uuid} id={'estabelecimento' + index} key={estabelecimento.uuid}>
                                                {estabelecimento.descritivo}
                                            </MenuItem>
                                        )}
                                    </Select>
                                </FormControl>
                            </Box>

                            <Box>
                                <Tooltip title="Configurações">
                                    <IconButton onClick={toggleConfiguracoes} sx={{ mr: "10px", mt: "6px" }}>
                                        <Icon className='fa-solid fa-bars' sx={{ color: theme.palette.background.default }} />
                                    </IconButton>
                                </Tooltip>

                                <Tooltip title="Opções">
                                    <>
                                        <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                                            <Avatar id="user_image" alt={`Foto ${token.USER_INFO?.nome ?? 'usuário'}`} src={token.USER_INFO?.avatar ?? '/static/images/avatar/1.jpg'} />
                                        </IconButton>
                                        {props.showConfiguracoes &&
                                            <Box
                                                sx={{
                                                    borderRadius: '3px',
                                                    background: theme.palette.background.default,
                                                    position: 'absolute',
                                                    top: '60px',
                                                    right: '0',
                                                    width: '100%',
                                                    maxWidth: '400px',
                                                    height: 'auto',
                                                    zIndex: 102,
                                                    padding: '20px',
                                                    boxShadow: '1px 1px 5px 2px rgba(0,0,0,.06)'
                                                }}
                                            >
                                                <CustomSelect
                                                    id='tabela-preco'
                                                    label={`Tabela de preço${!!preferenciaTabelaPreco?.length ? ' configurada na preferência do cadastro do cliente' : ''}`}
                                                    onSelect={(e) => onSelectTabelaPreco(e as string)}
                                                    optionLabel={'descritivo'}
                                                    optionValue={'uuid'}
                                                    options={sortArray(getTabelasDePreco(), { fieldToSort: 'descritivo' })}
                                                    value={tabelaPrecoRef.current?.uuid}
                                                />

                                                <CustomSelect
                                                    id='deposito'
                                                    label='Depósito'
                                                    onSelect={(e) => onSelectDeposito(e as string)}
                                                    optionLabel={'descritivo'}
                                                    optionValue={'uuid'}
                                                    options={sortArray(getDepositos(), { fieldToSort: 'descritivo' })}
                                                    value={getDepositoUUID()}
                                                    marginBottom='0'
                                                />

                                            </Box>
                                        }
                                    </>
                                </Tooltip>

                                <Menu
                                    sx={{ mt: '45px' }}
                                    id="menu-appbar"
                                    anchorEl={anchorElUser}
                                    anchorOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}
                                    keepMounted
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}
                                    open={Boolean(anchorElUser)}
                                    onClose={handleCloseUserMenu}
                                >
                                    {
                                        settings.map((setting) => (
                                            <MenuItem key={setting.label} onClick={setting.action}>
                                                <Typography textAlign="center">{setting.label}</Typography>
                                            </MenuItem>
                                        ))
                                    }
                                </Menu >

                            </Box >
                        </Box >
                    </Toolbar >
                </Container >
            </AppBar >
            <SideMenu />
            {
                dadosAlterarTabelaPrecoState.showConfirmaExclusao &&
                <ConfirmacaoExcluirSkuDialog
                    open={dadosAlterarTabelaPrecoState.showConfirmaExclusao}
                    onCancel={onCloseModalSkus}
                    onConfirm={onConfirmModalSkus}
                    dados={dadosAlterarTabelaPrecoState}
                />
            }
        </>
    );
};

export default Topbar;
